import { render, staticRenderFns } from "./ServiceFrequency.vue?vue&type=template&id=fab2a750&scoped=true&"
import script from "./ServiceFrequency.vue?vue&type=script&lang=js&"
export * from "./ServiceFrequency.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFrequency.vue?vue&type=style&index=0&id=fab2a750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab2a750",
  null
  
)

export default component.exports